import { usePlayer as useReactPlayer } from '@landr/react-player';
import { StreamEntityType } from 'types/enums';
import { PacksStream } from 'apollo/pack/pack.gql';
import { RepacksStream } from 'apollo/repack/repack.gql';
import { CUSTOM_STREAM_QUERY, SampleStream } from 'apollo/sample';
import { DocumentNode } from 'graphql';

export type PlayerInstance = ReturnType<typeof useReactPlayer>;

export interface PlayerProviderProps {
    children: React.ReactNode;
    streamEntityType: StreamEntityType;
    playerId?: string;
    keyboardEventRef?: React.RefObject<Element>;
    customStreamUrl?: string;
    notifyIsPlaying?: (isPlaying: boolean) => void;
}
export interface PlayerContextType {
    currentTime: number;
    loading: boolean;
    playing: boolean;
    totalTime: number;
    togglePlaying: () => void;
    playFromBeginning: () => void;
    seek: (value: number, playOnSeek?: boolean | undefined) => void;
}

export const StreamResponses: { [key in StreamEntityType]: string } = {
    [StreamEntityType.Packs]: 'packStream',
    [StreamEntityType.Repacks]: 'repackStream',
    [StreamEntityType.Samples]: 'sampleStream',
    [StreamEntityType.Custom]: 'customStream',
};

export const StreamQueries: { [key in StreamEntityType]: DocumentNode } = {
    [StreamEntityType.Packs]: PacksStream,
    [StreamEntityType.Repacks]: RepacksStream,
    [StreamEntityType.Samples]: SampleStream,
    [StreamEntityType.Custom]: CUSTOM_STREAM_QUERY,
};

export const StreamQueryVariables: { [key in StreamEntityType]: string } = {
    [StreamEntityType.Packs]: 'packGuid',
    [StreamEntityType.Repacks]: 'repackGuid',
    [StreamEntityType.Samples]: 'sampleGuid',
    [StreamEntityType.Custom]: 'customGuid',
};
